export enum AddPhotoAction {
  SetFileProgressValues = 'setFileProgressValues',
}
